import { parseJSONMap } from "slotworks/utils/json-utils";

export interface SymbolConfig {
    id: string;
    name: string;
    wild?: boolean;
    includeWilds?: boolean;
    scatter?: boolean;
    ways?: boolean;
    bonusId?: number;
    alwaysOnTop?: boolean;
    zIndex?: number;
    anticipation?: number;
    matchesMin?: number;
    matchesMax?: number;
    reels?: number[];
    validRows?: number[];
    size?: number;
    autoStick?: boolean;
    payouts?: any;
}

export default class SymbolDefinition {

    public id: string;
    public name: string;
    public wild: boolean;
    /**
     * Whether to include wild symbols towards a bonus match count
     */
    public includeWilds: boolean;
    public scatter: boolean;
    public ways: boolean;

    /**
     * bonusIds above 0 denote a bonus symbol, different values can be used to identify different types.
     */
    public bonusId: number;

    /**
     * Always z-sort this symbol above all others (deprecated, use zIndex)
     */
    public alwaysOnTop: boolean;

    /**
     * Z-sort position of this symbol
     */
    public zIndex: number;

    /**
     * Number of symbols that must be hit before anticipation starts
     */
    public anticipation: number;
    /**
     * Minimum matches to payout (used for bonus land sounds mostly)
     */
    public matchesMin: number;
    /**
     * Maximum matches possible (used to cancel anticipation when max has been hit)
     */
    public matchesMax: number;
    /**
     * Reels this symbol appears on. Used to determine whether to bother aniticpating or making land sounds
     */
    public reels: number[];
    /**
     * If set, contains a list of rows which this symbol will pay on
     */
    public validRows: number[];
    /**
     * The size of a stacked symbol which takes up more than 1 row
     */
    public size: number;
    /**
     * Upon landing this symbol should automatically stick
     */
    public autoStick: boolean;

    public payouts: Map<string, number>;

    constructor(symbolConfig: SymbolConfig) {
        this.id = symbolConfig.id;
        this.name = symbolConfig.name || symbolConfig.id;
        this.wild = symbolConfig.wild;
        this.scatter = symbolConfig.scatter;
        this.ways = symbolConfig.ways;
        this.includeWilds = symbolConfig.includeWilds;
        this.bonusId = symbolConfig.bonusId || 0;
        this.alwaysOnTop = symbolConfig.alwaysOnTop;
        this.zIndex = symbolConfig.zIndex;
        this.anticipation = symbolConfig.anticipation;
        this.matchesMin = symbolConfig.matchesMin;
        this.matchesMax = symbolConfig.matchesMax;
        this.reels = symbolConfig.reels;
        this.validRows = symbolConfig.validRows;
        this.size = symbolConfig.size || 1;
        this.autoStick = symbolConfig.autoStick;

        if (symbolConfig.payouts) {
            this.payouts = parseJSONMap<number>(symbolConfig.payouts);
        }
    }

    public isBonusSymbol() {
        return this.bonusId > 0;
    }
}
